import { makeStyles } from '@mui/styles'
import Chip from '@mui/material/Chip'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
      padding: theme.spacing(0.15),
    },
  },
  round: {
    borderRadius: '10px',
    width: '15px',
    height: '15px',
  },
}))
export default function StatusButton(props) {
  const classes = useStyles()
  const { color } = props
  return (
    <div className={classes.root}>
      <Chip
        className={props && props.className}
        avatar={<div className={`${classes[props.color]} ${classes.round}`} style={{ background: color }}></div>}
        label={props.text}
        size="small"
        variant="outlined"
      />
    </div>
  )
}
